import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { Cookie } from 'ng2-cookies/ng2-cookies';

import * as moment from 'moment';

@Injectable()
export class CommonService {

  public static getEwdApiURL() {
    return environment.api_url + environment.version;
  };

  public static getTransportApiURL() {
    return environment.transportapi_url + 'v1/';
  };

  public static getEmailApiURL() {
    return environment.emailapi_url + 'api/v1/';
  };

  public static getAuthrLoginUrl() {
    return environment.authr_login_url;
  };

  public static fromKmToMile(value: string) {
    return (+value.replace('km', '') * 0.621).toPrecision(2) + 'mi';
  }

  public static fromMileToKm(value: string) {
    return (+value.replace('km', '')) * 1.609;
  }

  public static loadTheme() {
    $('#themeChoices .theme.active').removeClass('active');
    if (Cookie.get('currentTheme') === 'dark') {
      $('#themeLink').attr('href', 'assets/css/dark.css');
      $('#themeNGLink').attr('href', 'node_modules/primeng/resources/themes/darkness/theme.css');
      $('#dark').addClass('active');

      const linkElement = '<link id=\'mydatelink\' rel=\'stylesheet\' href=\'/assets/css/override.css\' type=\'text/css\' >';
      const head = $('body');
      if ($('#mydatelink').length > 0) {
        $('LINK[href*=\'override.css\']').remove();
      }
      head.append(linkElement);
    } else {
      $('#themeLink').attr('href', 'assets/css/light.css');
      $('#themeNGLink').attr('href', 'node_modules/primeng/resources/themes/lightness/theme.css');
      $('#light').addClass('active');
      $('LINK[href*=\'override.css\']').remove();
    };
  }

  public static themeOnClicked() {
    $('#themeChoices li .theme').click(function() {
        const currentTheme = $('#themeChoices .theme.active').attr('id');
        const newTheme = $('#themeChoices .theme:not(.active)').attr('id');
        const clickedTheme = $(this).attr('id');

        if (clickedTheme === 'dark') {
          const linkElement = '<link id=\'mydatelink\' rel=\'stylesheet\' href=\'/assets/css/override.css\' type=\'text/css\' >';
          const head = $('body');
          head.append(linkElement);
        } else {
          $('LINK[id*=\'mydatelink\']').remove();
        };

        if (clickedTheme === newTheme) {
          $('#themeChoices').toggleClass('switch');

          $('#themeLink').attr('href', 'assets/css/' + clickedTheme + '.css');
          $('#themeNGLink').attr('href', 'node_modules/primeng/resources/themes/' + clickedTheme + 'ness/theme.css');
          $('#themeChoices .theme.active').removeClass('active');
          $(this).addClass('active');
          Cookie.set('currentTheme', clickedTheme, 365);

          setTimeout( function() {
            $('#themes').blur();
          }, 150);
        }
      });
  }

  public static getCellData(row: any, col: any): any {
    const nestedProperties: string[] = col.field.split('.');
    let value: any = row;
    for (const prop of nestedProperties) {
      value = value[prop];
    }
    return value;
  }

  public static ConvertToDateObject(date, isMyDatePicker): any {
    const dateObject = {date:  { year: date.year(), month: date.month(), day: date.date() }};
    if (isMyDatePicker) {
      dateObject.date.month += 1;
    }
    return dateObject;
  }

  public static ConvertToDate(dateObject, isMyDatePicker): any {
    let month = dateObject.date.month;
    if (isMyDatePicker) {
      month -= 1;
    }

    const date = moment(new Date(
      dateObject.date.year, month, dateObject.date.day), 'YYYY-MM-DD');

    return date;
  }

  public static dateFormatted(date) {
    return moment(date).format('DD/MM/YYYY')
  }

  public static datetimeFormatted(date) {
    return moment(date).format('DD/MM/YYYY HH:mm:ss')
  }

  public static timeFormatted(date) {
    return moment(date).format('HH:mm')
  }

  public static datetimeLocalFormatted(date) {
    return moment(new Date(date)).local().format('DD/MM/YYYY HH:mm');
  }

  public static datetimeLocalFormattedWithSeconds(date) {
    return moment(new Date(date)).local().format('DD/MM/YYYY hh:mm:ss A');
  }

  public static dateISOFormatted(date)
  {
    var d = moment(date).format('YYYY-MM-DD');
    return d;
  }

  public static dateTimeISOFormatted(date)
  {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }

  constructor() { }
}
